import { Einheit } from "./Einheit";
import React, { ReactNode } from "react";
import "./Menge.css"

const prettifiedEinheiten: Record<Einheit, (menge: number) => ReactNode> = {
    essloeffel: menge => <>{menge}&nbsp;EL</>,
    g: menge => <>{menge}&nbsp;g</>,
    ml: menge => <>{menge}&nbsp;ml</>,
    stueck: menge => <>{menge}x</>,
    teeloeffel: menge => <>{menge}&nbsp;TL</>,
};
export function Menge(props: { menge: number; einheit: Einheit; } & React.HTMLAttributes<HTMLSpanElement>) {
    return <span {...props} className={"menge " + (props.className ?? "")}>
        {prettifiedEinheiten[props.einheit](props.menge)}
    </span>;
}
